module.exports = __webpack_public_path__ + "static/media/bg_catalog.87e25dc3.webp";